Vue.component("Logo", {
    props: ["settings"],
    mixins: [MediaPathMixin],
    template: `
        <div id="logo" @click="home">
            <img v-for="logo in versions" :src="logo.src" :alt="alt" v-if="isLogoVisible(logo.name)">
        </div>
    `,
    data() {
        return {
            // variables defined in config.js
            src: this.settings.src,
            alt: this.settings.alttext,
            navigatesTo: this.settings.navigatesTo,
            versions: this.settings.versions,
            useLogoVersionOnRoute: this.settings.useLogoVersionOnRoute
        }
    },
    methods: {
        isLogoVisible (name) {
            
            // hvis vi tester alle med navn vil default altid være synlig.
            // bliver nød til at teste om der er noget i sættet der matcher først.
            const route = this.$route.path;

            // Find first match and then see if the name matches the argument.
            for(var i = 0; i < this.useLogoVersionOnRoute.length; i++) {

                const entity = this.useLogoVersionOnRoute[i];
                for(var j = 0; j < entity.match.length; j++) {
                    const pattern = new RegExp(entity.match[j], "gi");
                    let isMatch = pattern.test(route)
                    console.log(`testing pattern ${pattern} against route ${route}, match: ${isMatch}`)

                    if(isMatch) {
                        
                        return entity.name === name;
                    }
                }
            }
            return false;
        },
        navigateTo () {
            this.goto(this.navigatesTo);
        },
        home() {
            // call home function in PageScene
            //app.router.home();
        },
        goto(route) {
            // push route if navigatesto is a route.
            if (this.$router.currentRoute.path !== route)
            app.router.goto(route);
        },
        openLink(url) {
            // open external link if navigatesto is an external url
            window.open(url, "_blank");
        }
    },
    computed: {
    }
})